import { __rest, __awaiter } from './../../../../external/tslib/tslib.es6.js';
import React from 'react';
import { Input } from '@olist/design-system';
import { SearchOutline } from '@olist/design-system-icons';
import { InputContainer } from './styles.js';

function SearchInput(_a) {
    var { placeholder: placeholderProps, onSubmit } = _a, rest = __rest(_a, ["placeholder", "onSubmit"]);
    const placeholder = placeholderProps !== null && placeholderProps !== void 0 ? placeholderProps : '';
    const handleSubmitSearch = (e) => __awaiter(this, void 0, void 0, function* () {
        if (e.key === 'Enter' || e.keyCode === 13) {
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(e);
        }
    });
    return (React.createElement(InputContainer, { id: "olist-table-header-search-input" },
        React.createElement(Input, Object.assign({ placeholder: placeholder, prefix: SearchOutline, onKeyDown: handleSubmitSearch }, rest))));
}

export { SearchInput };
